import React, { useContext } from 'react'
import { arrayOf, exact, string, shape } from 'prop-types'

// component stack
import * as Styled from './CancerCenters.styles'
import { TextContext } from 'hocs/TextContextProvider/TextContextProvider'
import { Tooltip } from 'components/atoms'
import { certs } from 'assets/img'

const CancerCenters = ({ data }) => {
  const textContext = useContext(TextContext)
  const { tooltip, certificates } = data

  return (
    <Styled.CancerCenters>
      <div className='headline-container'>
        <span>
          <b>{textContext['cancerCenters.title']}</b>
        </span>
        <Tooltip
          arrow='left'
          className='tooltip'
          dialogTitle={ tooltip.title }
          infoIconId={ `info-icon` }
          tooltipId={ `tooltip` }>
          {tooltip.tip}
        </Tooltip>
      </div>
      <div
        className='cert-container'
        role='img'
        aria-label={ textContext['cancerCenters.title'] }>
        {certificates.map((certificate, index) => (
          <img
            key={ index }
            src={ certs[certificate.identifier] }
            alt={ certificate.title }
          />
        ))}
      </div>
    </Styled.CancerCenters>
  )
}

CancerCenters.propTypes = {
  data: shape({
    tooltip: exact({
      title: string.isRequired,
      tip: string.isRequired,
    }).isRequired,
    certificates: arrayOf(
      shape({
        title: string.isRequired,
        identifier: string.isRequired,
      })
    ),
  }).isRequired,
}

export default CancerCenters
